export enum SEARCH {
  PLACEHOLDER = 'Search',
}
